import axios from '@/axios'

class ReadyMadeCompanyDataService {
  async getAll(page: number): Promise<any> {
    return axios.get(`/ready-made-companies/getAll?page=${page}`)
  }

  async getById(id: number): Promise<any> {
    return axios.get(`/ready-made-companies/${id}/get`)
  }

  async create(data: any): Promise<any> {
    return axios.post('/ready-made-companies/create', data)
  }

  async update(id: number, data: any): Promise<any> {
    return axios.put(`/ready-made-companies/${id}/update`, data)
  }

  async delete(id: number): Promise<any> {
    return axios.delete(`/ready-made-companies/${id}`)
  }
}

export default new ReadyMadeCompanyDataService()
